<script>
import Vue from 'vue';
import DashboardAvailabilityGraph from '../DashboardAvailabilityGraph/DashboardAvailabilityGraph.vue';
import KeyValueMenu from '../KeyValueMenu/KeyValueMenu.vue';
import {mapState, mapActions, mapGetters} from 'vuex';
import Fake from '../Fake/Fake.vue';

export default Vue.extend({
    components: {
        Fake,
        KeyValueMenu,
        DashboardAvailabilityGraph
    },
    computed: {
        ...mapState({
            items: state => state.dashboard.availability.items,
            loading: state => state.dashboard.availability.loading,
            accommodation: state => state.dashboard.availability.accommodation
        }),
        ...mapGetters({
            getAccommodationsKeyValueObject: 'dashboard/getAccommodationsKeyValueObject'
        })
    },
    methods: {
        ...mapActions({
            availabilityAccommodationSet: 'dashboard/availabilityAccommodationSet'
        })
    }
});
</script>
<template>
    <div class="dashboard-availability">
        <div class="dashboard-availability__content">
            <div v-if="!loading" class="dashboard-availability__container">
                <div class="dashboard-availability__header">
                    <div class="dashboard-availability__heading">
                        {{ $t('dashboard.availability.overview') }}
                    </div>
                    <div class="dashboard-availability__filters">
                        <key-value-menu :label="$t('dashboard.availability.select')"
                                        :value="accommodation"
                                        :undefined-name="$t('dashboard.availability.all')"
                                        :items="getAccommodationsKeyValueObject"
                                        :enable-deselect="true"
                                        @input="availabilityAccommodationSet($event)"/>
                    </div>
                </div>
                <div v-if="items" class="dashboard-availability__graph">
                    <dashboard-availability-graph
                        :labels="[
                            $t('dashboard.availability.available'),
                            $t('dashboard.availability.request'),
                            $t('dashboard.availability.blocked')
                        ]"
                        :height="300"
                        :width="280"/>
                </div>
                <div v-if="!items" class="dashboard-availability__no-content">
                    <i class="fa fa-exclamation-circle"/><br>
                    {{ $t('dashboard.availability.noContent') }}
                </div>
                <div class="dashboard-availability__footer">
                    <div class="dashboard-availability__footer-text">
                        {{ $t('dashboard.graph.footer') }}
                    </div>
                </div>
            </div>
            <fake v-if="loading"
                  :header-rows="1"
                  :body-rows="12"
                  :body-cells="4"
                  :key="'fake'"/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/DashboardAvailability/DashboardAvailability.vue